import { IntegrationAddressInfoProps } from "@/modal/integration/address/info";
import { IntegrationAddressVo } from "@/types";
import { wrapUpDescriptions } from "@/utils/info";
import { Descriptions } from "antd";
import { useMemo } from "react";
import Indicator from "./Indicator";

type AddressInfoProps = {
  address: IntegrationAddressVo;
  className?: string;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
};

export default function AddressInfo(props: AddressInfoProps) {
  const { address, className, labelStyle, contentStyle } = props;
  const keyValues = useMemo(() => {
    const items = wrapUpDescriptions(
      IntegrationAddressInfoProps,
      address as Record<string, any>,
    );
    return items.map((item) => ({
      ...item,
      span: 1,
    }));
  }, [address]);

  const styles = useMemo(() => ({ label: labelStyle, content: contentStyle }), [labelStyle, contentStyle]);

  return (
    <div>
      <Indicator label="Address" />
      <Descriptions
        column={1}
        size="small"
        className={className}
        bordered
        items={keyValues}
        styles={styles}
      />
    </div>
  );
}
